module.exports = __webpack_public_path__ + "img/invoice-alternate.abe807cf.png";